import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "./rootSaga";
import { persistStore } from "redux-persist";
import rootReducer from "./rootReducer";

const sagaMiddleware = createSagaMiddleware();
const middleWare = [sagaMiddleware]

//------previous code start--------
// let store = createStore(
//     rootReducer,
//     composeWithDevTools(applyMiddleware(...middleWare))
// )
//------previous code end--------

//------new code start--- bellow logic prevent redux_devtool crash by huge tags array in project state -----
// const actionSanitizer = (action) => (
//         action.type === 'FETCH_TAGS_SUCCESS' && action.tags ?
//         { ...action, tags: '<<LONG_ARRAY>>' } : action
//       );

const actionSanitizer = (action) => {
  switch (true) {

    case action.type.includes("FETCH_TAGS_SUCCESS"):
      return typeof action.tags !== 'undefined'
        ? { ...action, tags: '[LONG_ARRAY]' } : action

    case action.type.includes("ADD_TIMEOUT_PAYLOAD"):
      return typeof action.payload !== 'undefined'
        ? { ...action, payload: '[LONG_ARRAY]' } : action

    case action.type.includes("CREATE_REVISION_START"):
      return typeof action.payload.recordsArr !== 'undefined'
        ? { ...action, payload: { ...action.payload, recordsArr: '[LONG_ARRAY]' } } : action

    case action.type.includes("UPDATE_REVISION_START"):
      return typeof action.payload.recordsArr !== 'undefined'
        ? { ...action, payload: { ...action.payload, recordsArr: '[LONG_ARRAY]' } } : action
    default:
      return action;
  }
};
const stateSanitizer = (state) => {

  let obj = { ...state };
  if (state.project?.tags) {
    obj = { ...obj, project: { ...obj.project, tags: '[LONG_ARRAY]' } }
  }

  if (state.revision?.timeOutApiPayload.length > 0) {

    obj = { ...obj, revision: { ...obj.revision, timeOutApiPayload: '[LONG_ARRAY]' } }
  }
  return obj


}

// const composeEnhancers = composeWithDevTools({
//     actionSanitizer,
//     stateSanitizer: (state) => state.project?.tags ? { ...state, project:{...state.project,tags: '<<LONG_ARRAY>>'} } : state
//   });

const composeEnhancers = composeWithDevTools({
  actionSanitizer,
  stateSanitizer
});

let store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(...middleWare),
    // other store enhancers if any
  )
)
//------new code end

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store)

export default store;



// const actionSanitizer = (action) =>{
//     console.log(action)
//     return (
//     action.type === 'FETCH_TAGS_SUCCESS' && action.tags ?
//     { ...action, tags: action.tags } : action
//   )};

// const composeEnhancers = composeWithDevTools({
//     actionSanitizer,
//     stateSanitizer: (state) => state.project?.tags ? { ...state, project:{...state.project,tags: state.project.tags} } : state
//   });

// let store = createStore(
//     rootReducer,
//     composeEnhancers(
//         applyMiddleware(...middleWare),
//         // other store enhancers if any
//       )
// )